import { render } from "./MessageBox.vue?vue&type=template&id=fb8eeb2c"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=fb8eeb2c&lang=css"
script.render = render

export default script